<template>
  <div class="bcg-gray">
    <div class="container px-10">
      <div class="row h4 b1 my-10">{{ $t("panelUser.comment") }}</div>
      <div class="row b1 mt-n5 mb-7">{{ $t("commentDiscription") }}</div>
      <div class="row">
        <div class="col-12 col-lg-6">
          <div class="row font14 gray-text">{{ $t("lastComment") }}</div>
          <div class="row justify font14">
            <div class="col-12 col-lg-8">{{ lastComment.opinion }}</div>
          </div>
          <div class="row">
            <v-rating
              dense
              v-model="lastComment.star"
              readonly
              background-color="orange lighten-3"
              color="orange"
              dir="ltr"
              class="w-100"
            ></v-rating>
          </div>
        </div>
        <div class="col-12 col-lg-6">
          <div class="row font14 gray-text">{{ $t("newComment") }}</div>
          <div class="row">
            <v-textarea
              maxlength="280"
              filled
              v-model="comment.opinion"
              :label="$t('yourEmail')"
            ></v-textarea>
          </div>
          <div class="row">
            <div
              class="col-12 col-lg-8 col-md-7 order-lg-12 order-md-12 order-sm-1 mt-n4"
            >
              <v-rating
                v-model="comment.star"
                length="5"
                background-color="orange lighten-3"
                color="orange"
                dir="ltr"
              ></v-rating>
            </div>

            <div
              align="center"
              class="col-12 col-lg-4 col-md-5 order-lg-1 order-md-1 pointer blue-bcg text-light rounded-pill mb-10"
              @click="sendcomment()"
            >
              {{ $t("submitComment") }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      lastComment: {
        star: null,
        opinion: "",
      },
      comment: {
        star: 3,
        opinion: "",
      },
    };
  },
  methods: {
    sendcomment() {
      this.axios.defaults.headers.common["Authorization"] =
        "Bearer " + this.$session.get("token");
      this.axios.post("account/opinion", this.comment).then((response) => {
        console.log(response);
        this.comment.star = 3;
        this.comment.opinion = "";
        this.$noty.success(this.$t("commentOk"));
        this.getcomment();
      });
    },
    getcomment() {
      this.axios.defaults.headers.common["Authorization"] =
        "Bearer " + this.$session.get("token");
      this.axios.get("get_one_opinion").then((response) => {
        console.log(response.data[0]);
        this.lastComment.star = response.data[0].star;
        this.lastComment.opinion = response.data[0].opinion;
      });
    },
  },
  mounted() {
    this.getcomment();
  },
};
</script>
